// extracted by mini-css-extract-plugin
module.exports = {"Card":"ChartSkeleton_Card__10S5u"};